import { render } from "./collection-50.vue?vue&type=template&id=2f46b5ce"
import script from "./collection-50.vue?vue&type=script&lang=js"
export * from "./collection-50.vue?vue&type=script&lang=js"

import "./collection-50.vue?vue&type=style&index=0&id=2f46b5ce&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__